module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a472ead89ea9546939c.worker.js");
};